import { CssBaseline, GlobalStyles, ThemeProvider, useMediaQuery } from '@mui/material';
import { darkTheme, theme } from '@puffin/ui-library';
import { NotificationCenter } from './notifications/NotificationCenter';
import { TaskCompletedAnimationCenter } from './notifications/TaskCompletedAnimationCenter';
import { useAppearancePreference } from '../state/configuration/appearance-preference';
import { AuthorizedArea } from '../services/auth/AuthProvider';
import { AuthenticatedApplication } from './AuthenticatedApplication';

export const App = () => {
  const prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
  const appearance = useAppearancePreference();
  const selectedTheme = appearance === 'dark' || (appearance === 'auto' && prefersDark) ? darkTheme : theme;

  return (
    <ThemeProvider theme={selectedTheme}>
      <CssBaseline enableColorScheme />
      <GlobalStyles styles={{ html: { overflowY: 'scroll' } }} />
      <NotificationCenter />
      <TaskCompletedAnimationCenter />
      <AuthorizedArea>
        <AuthenticatedApplication />
      </AuthorizedArea>
    </ThemeProvider>
  );
};
